// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__A7orQ","imageUploader":"EGiftCard_imageUploader__1Tg4_"};